import { CheckOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import "../search/searchandselect.css";

const MultiSelectCards = ({renderOptions, setOptions, defaultSetOptions, multiSelectCardType, readOnly}) => {

  const [states, setStates] = useState([]);
  const [cardClick, setCardClick] = useState({});
  const [customClassName, setCustomClassName] = useState("");

  
  useEffect(() => {
    if (multiSelectCardType === "rounded") {
      setCustomClassName("rounded-cards");
    } else {
      setCustomClassName("");
    }
    setStates(() => Object.keys(renderOptions));
    if (Object.keys(defaultSetOptions).length > 0) {
      setOptions({...defaultSetOptions});
      setCardClick(defaultSetOptions);
    } else {
      setOptions({...renderOptions});
      setCardClick(renderOptions)
    }
  },[defaultSetOptions.Morning, defaultSetOptions.monday])

  const handleCardClick = (item) => {
    if(!readOnly){
      setCardClick(prevValue => ({...prevValue, [`${item}`]:!prevValue[`${item}`] }));
      setOptions(prevValue => ({...prevValue, [`${item}`]:!prevValue[`${item}`] }));
    }
  }

  return (
    <div className="selected-items">
        {states.map((item, index) => (
          <Card 
            className={cardClick[item] ? `on-click-cards ${customClassName}` : `clickable-cards ${customClassName}`}
            key={index} 
            onClick={() => handleCardClick(item)}>
              <span>{customClassName ? item.charAt(0).toUpperCase() : item}</span> 
              {customClassName==="rounded-cards" ? null : (cardClick[item] && <CheckOutlined className='selected-items-check-icon'/>)}
          </Card>
        ))}
      </div>
  )
}

export default MultiSelectCards;

/**
 * Usage:
 * 
 * <MultiSelectCards props/>
 * 
 * props include:
 *  renderOptions -> options to select (array)
 *  setOptions -> contains an object of key-value pair where key: option and value: true | false
 *                true => selected option
 *                false => unselected option
 */